import { render, staticRenderFns } from "./Instances.vue?vue&type=template&id=59822de9&scoped=true&"
import script from "./Instances.vue?vue&type=script&lang=js&"
export * from "./Instances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59822de9",
  null
  
)

export default component.exports